import React, { useCallback, useEffect, useMemo, useState } from 'react';
import TableTitle from '../components/TableTitle';
import Table from '../components/Table';
import Pagination from '../components/Pagination/Pagination';
import usePagination from '../components/Pagination/usePagination';
import SearchBar from '../features/Events/SearchBar';
import { InfoOutlined } from '@mui/icons-material';
import { PAYMENT_STATUS, usePaymentsStore } from '../features/Payments/state/use-payments-store';

const LIMIT = 20;
const INITIAL_VALUES = { status: [] };

const Payments = () => {
  const { data, total, isLoading, error, fetchPayments, statusOptions } = usePaymentsStore();
  const { page, limit, updatePageUrl } = usePagination({ limit: LIMIT });

  const totalPages = Math.ceil(total / limit);

  const [searchValue, setSearchValue] = useState(INITIAL_VALUES);

  const handleSearch = useCallback(
    (value, name) => {
      setSearchValue((prev) => ({ ...prev, [name]: value }));
      updatePageUrl(1);
    },
    [updatePageUrl]
  );

  useEffect(() => {
    fetchPayments({ page, count: limit, searchParams: searchValue });
  }, [page, limit, searchValue]);

  const columns = useMemo(
    () => [
      {
        key: 'id',
        title: 'ID платежа',
      },
      {
        key: 'actions',
        title: 'Сумма',
        render: (row) => (
          <div className={'min-w-max'}>
            {row?.amount} {row?.currency}
          </div>
        ),
      },
      {
        key: 'status',
        title: 'Статус',
        render: (value) => {
          const status = PAYMENT_STATUS[value];
          return (
            <div className={'min-w-[100px] flex align-center gap-x-1'}>
              <span className={status?.className ?? 'text-gray-700'}>{status?.label ?? value ?? '-'}</span>
              <span>{status?.icon}</span>
            </div>
          );
        },
      },
      {
        key: 'confirmation_url',
        title: 'Ссылка на оплату',
        render: (value) =>
          value ? (
            <a href={value} target="_blank" rel="noreferrer" className="hover:text-orange-500 underline transition-colors">
              Открыть ссылку
            </a>
          ) : (
            '-'
          ),
      },
    ],
    []
  );

  const inputs = useMemo(
    () => [
      {
        label: 'По статусу',
        type: 'filter',
        options: statusOptions,
        selectedOptions: searchValue.status,
        className: 'max-w-[260px]',
        setSelectedOptions: (value) => handleSearch(value, 'status'),
        prefix: <InfoOutlined fontSize={'small'} className={'text-gray-500'} />,
      },
    ],
    [handleSearch, searchValue.status, statusOptions]
  );

  return (
    <div className="min-h-screen p-6 bg-gradient-to-r from-[#ededed] to-[#dcdcdc]">
      <div className="max-w-7xl mx-auto">
        <TableTitle title={'Платежи'} />
        <SearchBar inputs={inputs} />
      </div>
      <Table emptyText={'Платежи отсутствуют'} columns={columns} data={data ?? []} loading={isLoading} error={error}>
        {isLoading || error || totalPages <= 1 ? null : <Pagination totalPages={totalPages} withLimit={true} />}
      </Table>
    </div>
  );
};
export default Payments;
